import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-829d9892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-bg" }
const _hoisted_3 = { class: "back" }
const _hoisted_4 = { class: "login-box" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

import { ref, onMounted } from 'vue'
import { ElMessage, ElIcon } from 'element-plus'
import type { FormInstance } from 'element-plus'
import { useRouter } from 'vue-router'
import iconEmail from '@/assets/icons/icon-login-email.png'
import iconCode from '@/assets/icons/icon-login-code.png'
import iconLock from '@/assets/icons/icon-login-lock.png'
import { verificationcodeSend, passwordReset } from '@/api'
import { encode, sha } from '@/utils'
import { COUNT_NUMBER } from '@/common/constant'
import { passwordReg } from '@/common/regexp'
import { CaretLeft } from '@element-plus/icons-vue'
import LanSwitch from '@/components/lan-switch'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const verificationCodeError = ref('')

const router = useRouter()

const formRef: any = ref<FormInstance>()

const formData = ref({
  mail: '',
  newPassword: '',
  verificationCode: '',
})

const rules: any = {
  mail: [
    { required: true, message: t('LOGIN.emailPla') },
    { type: 'email', message: t('LOGIN.emailMsg') },
  ],
  newPassword: [
    { required: true, message: t('LOGIN.newPwdPla') },
    {
      pattern: passwordReg,
      message: t('LOGIN.pwdMsg'),
    },
  ],
  verificationCode: [
    { required: true, message: t('LOGIN.codeMsg'), trigger: 'change' },
  ],
}

const loading = ref(false)

const onSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const { mail, newPassword, verificationCode } = formData.value
      loading.value = true
      verificationCodeError.value = ''

      const res: any = await passwordReset({
        mail,
        newPassword: encode(newPassword),
        verificationCode: sha(verificationCode + encode(newPassword)),
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === 0) {
        ElMessage({
          message: res?.msg,
          type: 'success',
        })
        setTimeout(() => {
          toLogin()
        }, 1500)
      } else if (res?.code === 20200) {
        verificationCodeError.value = t('LOGIN.codeError')
      } else {
        ElMessage({
          message: res?.msg,
          type: 'error',
        })
      }
    }
  })
}

const sendVerificationcode = async () => {
  const { mail } = formData.value
  const res: any = await verificationcodeSend({
    mail,
  })
  if (res?.code === 0) {
    ElMessage({
      message: res?.msg,
      type: 'success',
    })
  } else {
    ElMessage({
      message: res?.msg,
      type: 'error',
    })
  }
}

// 倒计时
const number = ref(0)
const timer = ref(0)
const start = ref(false)
const countDown = () => {
  if (!formData.value.mail) {
    ElMessage({
      message: t('LOGIN.emailFirst'),
      type: 'error',
    })
    return
  }
  sendVerificationcode()
  number.value = COUNT_NUMBER
  start.value = true
  clearInterval(timer.value)
  timer.value = setInterval(() => {
    if (number.value === 0) {
      clearInterval(timer.value)
      start.value = false
      return
    }
    number.value = number.value - 1
  }, 1000)
}

const toLogin = () => {
  router.push('/login')
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(LanSwitch), {
      effect: "dark",
      class: "lan-switch"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back-box",
        onClick: toLogin
      }, [
        _createVNode(_unref(ElIcon), {
          class: "icon",
          size: "20",
          color: "#fff"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CaretLeft))
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('LOGIN.back')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('COMMON.platformName')), 1),
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          class: "form ws_mt30",
          model: formData.value,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "mail" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.mail,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.mail) = $event)),
                  modelModifiers: { trim: true },
                  size: "large",
                  placeholder: _ctx.$t('LOGIN.emailPla'),
                  maxlength: "50"
                }, {
                  prefix: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(iconEmail),
                      alt: ""
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "verificationCode",
              error: verificationCodeError.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.verificationCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.verificationCode) = $event)),
                  modelModifiers: { trim: true },
                  size: "large",
                  placeholder: _ctx.$t('LOGIN.codePla'),
                  maxlength: "10"
                }, {
                  prefix: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(iconCode),
                      alt: ""
                    }, null, 8, _hoisted_7)
                  ]),
                  suffix: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      disabled: start.value,
                      type: "info",
                      onClick: countDown,
                      class: _normalizeClass(["code", start.value ? 'code-disabled' : '']),
                      link: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(start.value
                      ? _ctx.$t('LOGIN.resetCode', { number: number.value })
                      : _ctx.$t('LOGIN.getCode')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "class"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["error"]),
            _createVNode(_component_el_form_item, { prop: "newPassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.newPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.newPassword) = $event)),
                  modelModifiers: { trim: true },
                  size: "large",
                  type: "password",
                  placeholder: _ctx.$t('LOGIN.newPwdPla'),
                  "show-password": "",
                  maxlength: "50"
                }, {
                  prefix: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(iconLock),
                      alt: ""
                    }, null, 8, _hoisted_8)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  loading: loading.value,
                  type: "primary",
                  onClick: onSubmit,
                  class: "btn",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('LOGIN.btnReset')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}
}

})